module.exports = __webpack_public_path__ + "img/202305230001_1280_toShop.5f3ec31a.jpg";